import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { StyledTabs, StyledTab } from "components/CustomTabs";
import { TabPanel } from "components/TabPanel";
import JumboIconButton from "@jumbo/components/JumboIconButton";
import JumboCodeBlock from "@jumbo/components/JumboCodeBlock";

import LaunchIcon from "@mui/icons-material/Launch";
import codeConstants from "app/utils/constants/codeConstants";

const CodeSnippets = ({ activeDetails, setCode, setEditorLanguage }) => {
  const [localCodeTabValue, setLocalCodeTabValue] = useState(0); // Local state for tabs

  const handleCodeTabChange = (event, newValue) => {
    setLocalCodeTabValue(newValue); // Only update local tab value
  };

  const handleImport = () => {
    let currentTabIndex = 0;
    for (
      let detailIndex = 0;
      detailIndex < activeDetails.length;
      detailIndex++
    ) {
      const detail = activeDetails[detailIndex];
      const snippetCount = detail.problemCodeSnippets.length;
      if (currentTabIndex + snippetCount > localCodeTabValue) {
        const snippetIndex = localCodeTabValue - currentTabIndex;
        if (detail && detail.problemCodeSnippets[snippetIndex]) {
          const languageKey =
            detail.problemCodeSnippets[snippetIndex].programmingLanguage;
          const languageConfig = codeConstants[languageKey];
          setCode(detail.problemCodeSnippets[snippetIndex].codeSnippet); // Update code
          setEditorLanguage(languageConfig?.language || "text"); // Update language
        }
        break;
      }
      currentTabIndex += snippetCount;
    }
  };

  return activeDetails.some(
    (detail) => detail.problemCodeSnippets.length > 0
  ) ? (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <StyledTabs
          value={localCodeTabValue}
          onChange={handleCodeTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {activeDetails.map((detail, detailIndex) =>
            detail.problemCodeSnippets.map((_, snippetIndex) => (
              <StyledTab
                iconPosition="start"
                key={`${detailIndex}-${snippetIndex}`}
                label={`Code Snippet`}
              />
            ))
          )}
        </StyledTabs>
        <JumboIconButton
          onClick={handleImport}
          tooltip="Import code to editor"
          color="success"
          sx={{ "&:hover": { opacity: 1, borderRadius: 2 } }}
        >
          <LaunchIcon />
        </JumboIconButton>
      </Box>
      {activeDetails.map((detail, detailIndex) =>
        detail.problemCodeSnippets.map((codeSnippet, snippetIndex) => {
          const tabIndex =
            activeDetails
              .slice(0, detailIndex)
              .reduce((acc, d) => acc + d.problemCodeSnippets.length, 0) +
            snippetIndex;
          return (
            <TabPanel
              key={`${detailIndex}-${snippetIndex}`}
              value={localCodeTabValue}
              index={tabIndex}
              height="auto"
            >
              <Box>
                <JumboCodeBlock
                  text={codeSnippet.codeSnippet}
                  language={codeSnippet.programmingLanguage.toLowerCase()}
                />
                <Typography variant="caption" sx={{ mt: 1 }}>
                  {codeSnippet.description}
                </Typography>
              </Box>
            </TabPanel>
          );
        })
      )}
    </>
  ) : null;
};

export default CodeSnippets;
